import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.less';
import {
  Form, Input, Button, message, Icon,
} from 'antd';
import { FormattedMessage } from 'react-intl';
import wrapReact from '../../../../../../util/react';
import { actUI } from '../../../../../../redux/action/ui';
import { msgCB } from '../../../../../../util/fetch/msgFetch';
import { CB_STATUS } from '../../../../../../util/fetch/cFetch';

const FormItem = Form.Item;

export class NewForm extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    const {
      intl, form, onSubmit, dispatch,
    } = this.props;
    const { formatMessage } = intl;
    const cb = (res) => {
      actUI(dispatch, {
        uiIndex: {
          uiHeader: { uiMenuUser: { uiFormSetting: { loading: false } } },
        },
      });
      switch (res.status) {
        case CB_STATUS.INVALID:
          message.config({
            top: 100,
            icon: <Icon type="close-circle" theme="filled" />,
          });
          return message.error(
            formatMessage({
              id: 'Header.userInexisted',
              defaultMessage: 'user is not existed',
            }),
          );
        default:
          return msgCB(res.status, formatMessage);
      }
    };
    form.validateFields((err, values) => {
      if (!err) {
        //                console.log('Received values of form: ', values);
        actUI(dispatch, {
          uiIndex: {
            uiHeader: { uiMenuUser: { uiFormSetting: { loading: true } } },
          },
        });
        onSubmit(values, cb);
      }
    });
  };

  render() {
    const {
      intl,
      form,
      filePath,
      className,
      auth,
      user,
      onCancel,
      ui,
    } = this.props;
    const { formatMessage } = intl;
    const { getFieldDecorator } = form;

    return (
      <Form
        layout="horizontal"
        onSubmit={this.handleSubmit}
        className={`${filePath} ${className}`}
      >
        <FormItem
          label={formatMessage({
            id: 'app.auth.email',
            defaultMessage: 'email',
          })}
        >
          {getFieldDecorator('email', {
            rules: [
              {
                required: true,
                type: 'email',
                message: formatMessage({
                  id: 'Header.emailInputCheck',
                  defaultMessage: 'please input email address',
                }),
              },
            ],
            initialValue: auth.email,
          })(<Input disabled />)}
        </FormItem>
        <FormItem
          label={formatMessage({
            id: 'app.auth.lastName',
            defaultMessage: 'last name',
          })}
        >
          {getFieldDecorator('lastName', {
            rules: [
              {
                required: true,
                message: formatMessage({
                  id: 'Header.lastNameInputCheck',
                  defaultMessage: 'please input last name',
                }),
              },
              {
                max: 32,
                min: 1,
                message: formatMessage({
                  id: 'validator.invalidLength',
                  defaultMessage: 'length of input is not ok',
                }),
              },
            ],
            initialValue: user.lastName,
          })(<Input />)}
        </FormItem>
        <FormItem
          label={formatMessage({
            id: 'app.auth.firstName',
            defaultMessage: 'first name',
          })}
        >
          {getFieldDecorator('firstName', {
            rules: [
              {
                required: true,
                message: formatMessage({
                  id: 'Header.firstNameInputCheck',
                  defaultMessage: 'please input first name',
                }),
              },
              {
                max: 32,
                min: 1,
                message: formatMessage({
                  id: 'validator.invalidLength',
                  defaultMessage: 'length of input is not ok',
                }),
              },
            ],
            initialValue: user.firstName,
          })(<Input />)}
        </FormItem>
        <FormItem className="btn-area">
          <Button type="primary" onClick={onCancel} className="form-bt">
            <FormattedMessage id="app.btn.cancel" defaultMessage="cancel" />
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={ui.loading}
            className="form-bt"
          >
            <FormattedMessage id="app.btn.ok" defaultMessage="ok" />
          </Button>
        </FormItem>
      </Form>
    );
  }
}

NewForm.propTypes = {
  auth: PropTypes.shape({
    email: PropTypes.string.isRequired,
  }).isRequired,
  user: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
  }).isRequired,
  intl: PropTypes.shape({
    locale: PropTypes.oneOf(['en', 'de']),
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  ui: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default Form.create()(
  wrapReact(NewForm, 'container_index_header_menu_menuUser_FormSetting'),
);
